export default __webpack_public_path__ + "static/media/man3.e71c303a.jpg";